import { GerenciadorPrecos } from '../../../../@types/GerenciadorPrecos';

type RowData = GerenciadorPrecos.RowData;

export const hasHighlightedOfferPriceStatus = (rowData: Pick<RowData, 'offerDetails'>): boolean => {
  const priceStatus = rowData.offerDetails?.priceStatus?.toUpperCase();

  const highlightedStatuses = ['EDITED', 'EDITADO', 'AUTO'];

  if (!priceStatus) return false;

  return highlightedStatuses.includes(priceStatus);
};
